import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { userStore } from 'entities/user/model/user-store';
import { observer } from 'mobx-react-lite';
import { TokenStorage } from 'shared/lib/token-storage';

export const PrivateRoute: React.FC = observer(() => {
  const isAuthenticated = TokenStorage.hasTokens();
  const location = useLocation();

  if (!isAuthenticated) {
    // Store the attempted location so we can redirect back after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
});